import apiClient from './apiClient';

export const fetchData = async (endpoint: string): Promise<any> => {
  const response = await apiClient.get(endpoint);
  return response.data;
};
